import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-bg",
  "use": "icon-flag-bg-usage",
  "viewBox": "0 0 1541 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1541 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-bg\"><defs><style type=\"text/css\"></style></defs><path d=\"M6.29 1017.718h1519.038V7.538H6.29v1010.18z m1521.55 2.513v-3.77 3.77zM0.009 1024V0H1531.61v1022.744H0.008z\" fill=\"#353636\" p-id=\"2624\" /><path d=\"M2.52 680.991h1525.32v339.24H2.52z\" fill=\"#D24826\" p-id=\"2625\" /><path d=\"M2.52 343.009h1525.32v339.239H2.52z\" fill=\"#009E79\" p-id=\"2626\" /><path d=\"M2.52 3.77h1525.32v339.239H2.52z\" fill=\"#FFFFFF\" p-id=\"2627\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-bg.svg
// module id = uiqu
// module chunks = 24